import React from 'react';
import {  formatCompactTonnes } from '../utils/formatNumber';

const ContainersInTransit = ({ data, shippingStatus }) => {
  // Calculate percentages for progress bars
  const totalWeight = shippingStatus.total_weight || 1; // Avoid division by zero
  const transitPercent = ((shippingStatus.transit / totalWeight) * 100).toFixed(0);
  const deliveredPercent = ((shippingStatus.delivered / totalWeight) * 100).toFixed(0);
  const delayPercent = ((shippingStatus.delay / totalWeight) * 100).toFixed(0);



  return (
    <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
      <h2 className="text-xl font-semibold mb-6">Containers in Transit</h2>

      <div className="space-y-4">
        {/* In Transit */}
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-gray-400">In Transit</span>
            <span className="text-white">
              {formatCompactTonnes(shippingStatus.transit)} tonnes
            </span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2">
            <div
              className="bg-gray-500 h-2 rounded-full"
              style={{ width: `${transitPercent}%` }}
            ></div>
          </div>
        </div>

        {/* Delivered */}
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-green-400">Delivered</span>
            <span className="text-white">
              {formatCompactTonnes(shippingStatus.delivered)} tonnes
            </span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2">
            <div
              className="bg-green-500 h-2 rounded-full"
              style={{ width: `${deliveredPercent}%` }}
            ></div>
          </div>
        </div>

        {/* Delayed */}


        <div>
          <div className="flex justify-between mb-2">
            <span className="text-red-400">Delayed</span>
            <span className="text-white">
              {formatCompactTonnes(shippingStatus.delay)} tonnes
            </span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2">
            <div
              className="bg-red-500 h-2 rounded-full"
              style={{ width: `${delayPercent}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContainersInTransit;